<template>
  <b-modal
    id="modal-field"
    :title="editMode == true ? $t('general.edit') : $t('general.add_application')"
    :ok-title="editMode == true ? $t('general.edit') : $t('general.save')"
    cancel-variant="outline-secondary"
    ok-variant="success"
    :cancel-title="$t('cancel')"
    centered
    no-close-on-backdrop
    @show="showModal"
    @ok="onSubmit"
  >
    <validation-observer ref="instrumentAddModal">
      <b-row class="material">

        <b-col md="12">
          <b-form-group :label="$t('brigade')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('brigade')"
              rules="required"
            > -->
              <v-select
                v-model="instruments.brigade"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_BRIGADE.results"
              >
                <!-- @input="onBrigadeSelected()" -->
                <li slot="list-footer" class="pagination">
                  <button :disabled="!GET_BRIGADE.previous" @click="previousBridge">
                    {{ $t("prev") }}
                  </button>
                  <button :disabled="!GET_BRIGADE.next" @click="nextBridge">
                    {{ $t("next") }}
                  </button>
                </li>
              </v-select>
              <!-- <small class="text-danger">{{ errors[0] }}</small> -->
            <!-- </validation-provider> -->
          </b-form-group>
        </b-col>
        
        <b-col md="12">
          <b-form-group :label="$t('reference.categoriya')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('reference.categoriya')"
              rules="required"
            > -->
              <v-select
                v-model="instruments.title"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_INSTRUMENT_CATEGORIES.results"
                @input="getInstrument"
              />
              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('reference.instruments_type')">
            <!-- <validation-provider
              #default="{ errors }"
              :name="$t('reference.instruments_type')"
              rules="required"
            > -->
              <v-select
                v-model="instruments.type"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                label="title"
                :options="GET_INSTRUMENTS_MODEL.results"
                :filterable="false"
                @input="getInstrumentModel"
                @search="onSearch1"
              >
                <li slot="list-footer" class="pagination">
                  <button
                    :disabled="!GET_INSTRUMENTS_MODEL.previous"
                    @click="previous"
                  >
                    {{$t('prev')}}
                  </button>
                  <button
                    :disabled="!GET_INSTRUMENTS_MODEL.next"
                    @click="nextFunc"
                  >
                    {{$t('next')}}
                  </button>
                </li>
              </v-select>

              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('sidebar.instrument')">
            <validation-provider
              #default="{ errors }"
              :name="$t('sidebar.instrument')"
              rules="required"
            >
              <v-select
                v-model="instruments.instrument_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="GET_INSTRUMENTS_MODEL_VARIANT.results"
                :filterable="false"
                @search="onSearch"
                @input="onInstrumentSelected"
                label="title"
              >
                <li slot="list-footer" class="pagination">
                  <button
                    :disabled="!GET_INSTRUMENTS_MODEL_VARIANT.previous"
                    @click="previousVariant"
                  >
                    {{$t('prev')}}
                  </button>
                  <button
                    :disabled="!GET_INSTRUMENTS_MODEL_VARIANT.next"
                    @click="nextFuncVariant()"
                  >
                    {{$t('next')}}
                  </button>
                </li>
              </v-select>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group :label="$t('amount')">
            <validation-provider
              #default="{ errors }"
              :name="$t('amount')"
              rules="required"
            >
              <b-form-input
                v-model="instruments.count"
                type="text"
                @input="formatPrice(instruments.count, 'count')"
                onkeypress="return /[0-9,/.]/i.test(event.key)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group :label="$t('contact.comment')">
            <validation-provider
              #default="{ errors }"
              :name="$t('contact.comment')"
              rules="required"
            >
              <b-form-textarea v-model="instruments.comment" type="text" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BRow, BCol, BFormGroup, BFormInput, BFormTextarea, BModal } from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { required } from "@core/utils/validations/validations";
import priceFormatMixin from "@/mixins/priceFormatMixin";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BModal,
  },
  props: {
    instrumentss: {
      type: Object,
      default: () => ({}),
      required: false,
    },
  },
  mixins: [priceFormatMixin],
  data() {
    return {
      // ===============  PRIMARY_DATA_SECTION START ===============
      required,
      getInsModel: [],

      search: "",
      search1: "",

      instruments: {
        id: null,
        brigade: null,
        instrument_id: null,
        title: null,
        type: null,
        count: null,
        comment: null
      },
      editMode: false,
    };
    // ===============  PRIMARY_DATA_SECTION END ===============
  },
  computed: {
    ...mapGetters("instruments", [
      "GET_INSTRUMENT_CATEGORIES",
      "GET_INSTRUMENTS_MODEL",
      "GET_INSTRUMENTS_MODEL_VARIANT",
    ]),
    ...mapGetters("brigade", [
      "GET_BRIGADE",
    ]),


  },
  async mounted() {
    // ===============  PRIMARY_REQUESTS_SECTION START ===============
    await this.FETCH_INSTRUMENTS_CATEGORY({ page_size: 500 });
    this.GET_INSTRUMENT_CATEGORIES.results.unshift({
      id: null,
      title: this.$i18n.locale == "ru" ? "Все" : "Barchasi",
    });
    await this.FETCH_BRIGADE();
    // ===============  PRIMARY_REQUESTS_SECTION END ===============
  },
  methods: {
    ...mapActions("instruments", [
      "FETCH_INSTRUMENTS_CATEGORY",
      "FETCH_INSTRUMENTS_MODEL",
      "FETCH_INSTRUMENTS_MODEL_VARIANT",
    ]),
    ...mapActions("brigade", [
      "FETCH_BRIGADE",
    ]),




    async nextFuncVariant() {
      if (this.GET_INSTRUMENTS_MODEL_VARIANT.next) {
        const page = this.GET_INSTRUMENTS_MODEL_VARIANT.next;

        await this.FETCH_INSTRUMENTS_MODEL_VARIANT({
          product: this.instruments && this.instruments.type &&
           this.instruments.type.id ? this.instruments.type.id : null,
          page: page,
          pagination: "number",
          search: this.search
        });
      }
    },

    async previousVariant() {
      if (this.GET_INSTRUMENTS_MODEL_VARIANT.previous) {
        const page = this.GET_INSTRUMENTS_MODEL_VARIANT.previous;

        await this.FETCH_INSTRUMENTS_MODEL_VARIANT({
          product: this.instruments && this.instruments.type && 
          this.instruments.type.id ? this.instruments.type.id : null,
          page: page,
          pagination: "number",
          search: this.search
        });
      }
    },

    async previous() {
      if (this.GET_INSTRUMENTS_MODEL.previous) {
        const page = this.GET_INSTRUMENTS_MODEL.previous;

        await this.FETCH_INSTRUMENTS_MODEL({
          category: this.instruments && this.instruments.title
           && this.instruments.title.id ? this.instruments.title.id : null,
          page: page,
          pagination: "number",
        });
      }
    },
    
    async nextFunc() {
      if (this.GET_INSTRUMENTS_MODEL.next) {
        const page = this.GET_INSTRUMENTS_MODEL.next;

        await this.FETCH_INSTRUMENTS_MODEL({
          category: this.instruments && this.instruments.title
           && this.instruments.title.id ? this.instruments.title.id : null,
          page: page,
          pagination: "number",
        });
      }
    },

    async previousBridge() {
      if (this.GET_BRIGADE.previous) {
        const page = this.GET_BRIGADE.previous;

        await this.FETCH_BRIGADE({ page: page, pagination: "number" });
      }
    },

    async nextBridge() {
      if (this.GET_BRIGADE.next) {
        const page = this.GET_BRIGADE.next;

        await this.FETCH_BRIGADE({ page: page, pagination: "number" });
      }
    },

    // ===============  SEARCH_SECTION START ===============
    async onSearch(query) {
      this.search = query;
      await this.FETCH_INSTRUMENTS_MODEL_VARIANT({
        product: this.instruments && this.instruments.type &&
         this.instruments.type.id ? this.instruments.type.id : null,
        search: query,
        pagination: "number",
      });
    },
    async onSearch1(query) {
      await this.FETCH_INSTRUMENTS_MODEL({
        search: query,
        pagination: "number",
      });
    },
    // ===============  SEARCH_SECTION END ===============

    formatPrice(value, type) {
      if (value) {
        let currency = value.toString().replace(/,/g, "");
        currency = parseFloat(currency);
        currency = new Intl.NumberFormat("en-US", {
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(currency);

        if (type == "count") {
          this.instruments.count = currency;
        }
      }
      return 0;
    },

    // ===============  SHOW_MODAL_SECTION START ===============
    showModal() {
      this.editMode = this.$route.params.editMode;
      this.instruments = {
        id: null,
        brigade: null,
        instrument_id: null,
        title: null,
        type: null,
        count: null,
        comment: null,
      };

      if (!this.instrumentss) {
        return;
      }

      if (typeof this.instrumentss === "object" && this.instrumentss !== null) {
        if (!this.instrumentss) {
          return;
        }
        this.instruments.id = this.instrumentss.id;
        this.instruments.brigade = this.instrumentss.brigade;
        this.instruments.instrument_id = this.instrumentss.instrument_id;
        this.instruments.count = this.instrumentss.count;
        this.instruments.title = this.instrumentss.title;
        this.instruments.type = this.instrumentss.type;
        this.instruments.comment = this.instrumentss.comment;
      }
    },
    // ===============  SHOW_MODAL_SECTION END ===============

    // ===============  ON_SUBMIT_SECTION START ===============
    async onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault();
      await this.$refs.instrumentAddModal.validate().then(async (success) => {
        if (!success) {
          this.$_errToast({message: this.$t('all_fields_are_required')});
          return;
        }
        try {
          this.$nextTick(() => {
            this.$route.params.editMode = false;
            this.$emit("onSave", this.instruments);
            this.$bvModal.hide("modal-field");
          });
          this.$_okToast();
        } catch (err) {
          console.log(err);
          // this.$_errToast('Error')
        }
      });
    },
    // ===============  ON_SUBMIT_SECTION END ===============

    // ===============  INSTRUMENTS_GET_SECTION START ===============
    async getInstrument(data) {
      if (data.id == 0) {
        await this.FETCH_INSTRUMENTS_MODEL({ pagination: "number" });
      } else {
        this.FETCH_INSTRUMENTS_MODEL({
          category: data.id,
          pagination: "number",
        });
      }
    },
    async getInstrumentModel(data) {
      if (!data) {
        this.getInsModel = [];
        this.instruments.instrument_id = null;
      } else {
        this.FETCH_INSTRUMENTS_MODEL_VARIANT({
          type: data.id,
          pagination: "number",
        }).then(() => {
          this.getInsModel = this.GET_INSTRUMENTS_MODEL.results;
        });
      }

      
      if(data.category && data.category.id && data.category.title){
        // if(this.goods.category == '' || this.goods.category == null){
        this.instruments.title = {id: data.category.id, title: data.category.title}
      }
    },
    onInstrumentSelected(value){
      // if(this.goods.title == '' || this.goods.title == null || this.goods.category == '' || this.goods.category == null){
      if(value && value.type && value.type.id && value.type.title && value.type.category && value.type.category.id && value.type.category.title){
        this.instruments.type = {id: value.type.id, title: value.type.title}
        this.instruments.title = {id: value.type.category.id, title: value.type.category.title}
      }
    },
    

    // ===============  INSTRUMENTS_GET_SECTION END ===============
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.material .vs--disabled .vs__dropdown-toggle,
[dir] .vs--disabled .vs__clear,
[dir] .vs--disabled .vs__search,
[dir] .vs--disabled .vs__selected,
[dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: transparent !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
